import {createApp} from 'vue/dist/vue.esm-bundler.js';
import Search from './components/breedFinder/search';
import Filter from './components/breedFinder/filter';
import List from './components/breedFinder/list';
import jumpTo from 'jump.js';

const startApp = (data) => {
    createApp({
        components: {
            Search: Search,
            Filter: Filter,
            List: List,
        },
        data() {
            return {
                images: data.images,
                language: data.language,
                items: data.breeds,
                activeFilter: [],
                query: "",
            }
        },
        mounted() {
          const buttonScrollTop = this.$refs['scrollTopBtn'];

          if (buttonScrollTop) {
            document.addEventListener("scroll", this.handleScroll);
            buttonScrollTop.addEventListener("click", this.scrollToTop);
          }
        },
        computed: {
            filteredItems() {
                let filteredItems = [...this.items];
                const query = this.query;
                const filter = this.activeFilter;

                if (typeof query === "string" && query.trim() !== "") {
                    filteredItems = filteredItems.filter(({name}) => {
                        return name.toLowerCase().indexOf(query.trim().toLowerCase()) >= 0;
                    });
                }

                if (filter.length > 0) {
                    const sizeFilters = filter.filter(x => x.property === "size");
                    const typeFilters = filter.filter(x => x.property === "type");
                    filteredItems = this.filterItems(filteredItems, sizeFilters);
                    filteredItems = this.filterItems(filteredItems, typeFilters);
                }

                return filteredItems;
            },
            sizeOptions() {
                return Object.keys(this.language.sizes).map(key => ({
                    label: this.language.sizes[key],
                    value: key,
                }));
            },
            typeOptions() {
                return Object.keys(this.language.types).map(key => ({
                    label: this.language.types[key],
                    value: key,
                }));
            },
        },
        methods: {
            filterItems(items, filters) {
                if (filters.length <= 0) {
                    return items;
                }

                return items.filter(item => {
                    return filters.some(filter => {
                        const {property, value} = filter;

                        return item[property] === value;
                    })
                });
            },
            /**
             * When the user scrolls down 20px from the top of the document, show the button
             */
            handleScroll() {
                const buttonScrollTop = this.$refs['scrollTopBtn'];
                if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                    buttonScrollTop.classList.add("active");
                } else {
                    buttonScrollTop.classList.remove("active");
                }
            },
            /**
             * When the user clicks on the button, scroll to the top of the document
             */
            scrollToTop(event) {
                event.preventDefault();
                jumpTo(document.body, {duration: 1000, offset: 0,});
            },
            onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            },
            resetFilter(event) {
                if (event) {
                    event.preventDefault();
                }
                this.activeFilter = [];
            },
            setFilter({ property, value }) {
                const index = this.activeFilter.findIndex((filter) => {
                    return filter.property === property && filter.value === value;
                });

                if (index === -1) {
                    return this.activeFilter.push({ property, value });
                }

                return this.activeFilter.splice(index, 1);
            },
            changeQuery(query) {
                if (typeof query === "string") {
                    this.query = query.trim();
                }
            }
        },
        template: `
          <div class="container">
            <header class="bg-white pt-2 pb-1 pt-md-3 px-lg-4 px-lg-5 mt-lg-n5 mt-xxl-n6 z-index-2">
              <Search :query="query" @onChange="changeQuery" :i18n="language" />
              <Filter
                  :size-options="sizeOptions"
                  :type-options="typeOptions"
                  :activeFilter="activeFilter"
                  :totalItemCount="items.length"
                  :itemCount="filteredItems.length"
                  @setFilter="setFilter"
                  @resetFilter="resetFilter"
                  :optionIcons="images.sizes"
                  :filterIcons="images.filterIcons"
                  :i18n="language"
              />
            </header>
            <List :items="filteredItems" :placeholder="images.placeholder" :i18n="language" />
          </div>
          <a href="#" ref="scrollTopBtn" class="btn-breed-top me-1 mb-1 me-md-2 mb-md-2" id="scrollTopBtn"><img :src="images.scrollTop" class="img-fluid" alt="Scroll top button"></a>
        `
    }).mount("#app-breedfinder");
}

startApp(window.breedFinderData);
